export const Logo = ({ size = 38 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" data-testid="rawdahpass-logo" aria-hidden="true">
    <defs>
      <linearGradient id="rpGrad" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
    <path d="M24 5c0 0-13 9.8-13 21.5V35h26v-8.5C37 14.8 24 5 24 5Z" stroke="url(#rpGrad)" strokeWidth="2.8" strokeLinejoin="round" />
    <path d="M9 38h30" stroke="url(#rpGrad)" strokeWidth="2.8" strokeLinecap="round" />
    <circle cx="24" cy="21" r="3.6" fill="url(#rpGrad)" />
    <path d="M24 24.6V32" stroke="url(#rpGrad)" strokeWidth="3.6" strokeLinecap="round" />
  </svg>
);

export const Wordmark = () => (
  <div className="flex items-center gap-2.5" data-testid="rawdahpass-wordmark">
    <Logo />
    <div className="leading-none">
      <span className="font-display font-extrabold tracking-tight text-lg text-white">
        INDO<span className="text-sky-400">RAWDAH</span>
      </span>
      <p className="text-[10px] font-mono2 uppercase tracking-[0.22em] text-slate-400 mt-1">Permit Rawdah Service</p>
    </div>
  </div>
);
